window.theme = window.theme || {};

/**
 * Scroll Position Memory - Saves user's scroll position when navigating away
 * and restores it when returning. Uses sessionStorage
 * to track position for the last 3 visited URLs and restores scroll on page load.
 */
theme.scrollMemory = {
  init: function () {
    // Skip initialization if browser is Safari
    if (this.isSafari()) {
      return;
    }

    this.onLoadRestorePosition();
    this.setupEventListeners();
  },

  setupEventListeners: function () {
    window.addEventListener("beforeunload", this.saveScrollPosition.bind(this));
  },

  getCurrentUrl: function () {
    return window.location.pathname;
  },

  isSafari: function () {
    // Detect Safari browser
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  },

  getStoredPositions: function () {
    var savedPositions = sessionStorage.getItem("lastScrollPositions");
    if (savedPositions) {
      try {
        return JSON.parse(savedPositions) || [];
      } catch (e) {
        console.error("Error parsing saved scroll positions:", e);
        return [];
      }
    }
    return [];
  },

  saveScrollPosition: function () {
    // Only save position if we've scrolled down
    if (window.scrollY > 100) {
      var currentUrl = this.getCurrentUrl();
      var positions = this.getStoredPositions();

      // Check if this URL is already in the array
      var existingIndex = positions.findIndex(function (item) {
        return item.url === currentUrl;
      });

      var positionData = {
        url: currentUrl,
        position: window.scrollY,
        timestamp: Date.now(), // Add timestamp to help with sorting
      };

      if (existingIndex >= 0) {
        // Update existing position
        positions[existingIndex] = positionData;
      } else {
        // Add new position
        positions.push(positionData);

        // Keep only the 3 most recent positions
        if (positions.length > 3) {
          // Sort by timestamp (newest first)
          positions.sort(function (a, b) {
            return b.timestamp - a.timestamp;
          });

          // Keep only the first 3
          positions = positions.slice(0, 3);
        }
      }

      sessionStorage.setItem("lastScrollPositions", JSON.stringify(positions));
    }
  },

  onLoadRestorePosition: function () {
    var currentPageUrl = this.getCurrentUrl();
    var positions = this.getStoredPositions();

    // Find position for current URL
    var matchingPosition = positions.find(function (item) {
      return item.url === currentPageUrl;
    });

    if (matchingPosition && matchingPosition.position) {
      setTimeout(
        function () {
          window.scrollTo({
            top: matchingPosition.position,
            behavior: "auto",
          });

          // Remove this URL from the stored positions after restoring
          var updatedPositions = positions.filter(function (item) {
            return item.url !== currentPageUrl;
          });

          sessionStorage.setItem(
            "lastScrollPositions",
            JSON.stringify(updatedPositions)
          );
        }.bind(this),
        100
      );
    }
  },
};

theme.scrollMemory.init();
